import initialState from "./initialState";
import configureStore from "./configureStore";

const store = configureStore(initialState);

export default store;
